import { render, staticRenderFns } from "./icon-check-mark.vue?vue&type=template&id=2104e5f8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2104e5f8')) {
      api.createRecord('2104e5f8', component.options)
    } else {
      api.reload('2104e5f8', component.options)
    }
    module.hot.accept("./icon-check-mark.vue?vue&type=template&id=2104e5f8&", function () {
      api.rerender('2104e5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/icons/icon-check-mark.vue"
export default component.exports